export type ThemePreference = "light" | "dark" | "system";
export const THEME_KEY = "talahwa-theme";

export function applyTheme(preference: ThemePreference): void {
  const dark = preference === "dark" || (preference === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  localStorage.setItem(THEME_KEY, preference);
}

/** The theme actually in effect, resolving "system" and following live changes.
 *  Read from the root element that applyTheme writes, so it cannot drift. */
export function resolvedTheme(): "light" | "dark" {
  return document.documentElement.dataset.theme === "dark" ? "dark" : "light";
}
